import React from 'react';
import {injectIntl} from "react-intl";

class WarningMessage extends React.Component {

  render() {
    const {title, text} = this.props;
    return (
      <div className="alert alert--error">
        <svg className="alert__icon" aria-hidden="true">
          <use xlinkHref="#icon-warning"></use>
        </svg>
        { title && <h2 className="alert__title">{title}</h2>}
        <div className="alert__desc">
          { text }
        </div>
      </div>
    );
  }
}

export default injectIntl(WarningMessage);



// WEBPACK FOOTER //
// ./src/components/common/WarningMessage.js